module.exports = __webpack_public_path__ + "static/media/p2008city.e1a216ab.jpg";